import React from 'react';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

type LinkButtonProps = {
  text: string;
  onClick: () => void;
};

const LinkButton: React.FC<LinkButtonProps> = ({ text, onClick }) => (
  <Link
    href="#"
    underline="none"
    variant="subtitle2"
    noWrap
    sx={{
      display: 'flex',
      alignItems: 'center',
      color: 'text.secondary',
      cursor: 'pointer',
      '&:hover': {
        color: 'primary.main',
      },
    }}
    onClick={(e) => {
      e.preventDefault(); // Prevents default link behavior
      onClick();
    }}
  >
    <Box
      component="svg"
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      marginRight={0.5}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
      />
    </Box>
    {text}
  </Link>
);

export default LinkButton;
